<app-page-wrapper>
  <div class="verify-wrapper">
    <app-heavy-header title="Verify Mobile Number"
      description="For quicker jet membership verification, use the number tied to your membership"></app-heavy-header>

    <div class="ss-verify-widget">
      <div class="sms-loading-wrapper" *ngIf="
          isSendingCode ||
          isUpdatingUserAccount ||
          isVerifyingCode
        ">
        <app-spinner size="32px"></app-spinner>
      </div>

      <section *ngIf="!isSendingCode && !isUpdatingUserAccount && !isVerifyingCode">
        <section *ngIf="!isPhoneVerified && !isCodeSent">
          <div class="phone-header-text">Enter Mobile Number</div>
          <app-phone-input [(ngModel)]="phoneValue" name="phone" required="true" (e164Change)="onE164Change($event)"></app-phone-input>

          <app-alert-message *ngIf="verificationError" type="error">
            {{verifyErrorText}}
          </app-alert-message>

          <app-primary-btn mb="24px" mt="24px" gradient="true" [disabled]="isSendingCode || !isPhoneFormatValid"
            (click)="onClickConfirmPhoneNumber()">
            Verify
          </app-primary-btn>
          <div class="sms-info">
            Only valid US mobile numbers are supported at this time.
          </div>
        </section>

        <section class="code-entry-wrapper" *ngIf="isCodeSent && !isPhoneVerified">
          <div class="phone-header-text">Verification Code</div>
          <ng-otp-input (onInputChange)="onCodeChange($event)" [config]="{
              length: 6,
              allowNumbersOnly: true,
              inputClass: 'code-input',
              containerClass: 'sms-code-input-row'
            }"></ng-otp-input>
          <app-alert-message *ngIf="verificationError" type="error">
            {{verifyErrorText}}
          </app-alert-message>
          <div class="sms-info">
            Code sent to: {{ phoneNumber }}
          </div>
          <button class="resend-code-btn" type="button" [disabled]="isSendingCode || resendCooldownSeconds > 0"
            (click)="onResendCode()">
            {{ resendCooldownSeconds > 0 ? 'Resend in ' + resendCooldownSeconds + 's' : 'Resend code' }}
          </button>
          <button class="retry-number-btn" type="button" (click)="onRetryNumber()">Use a different number</button>
        </section>
      </section>
    </div>
  </div>

</app-page-wrapper>
